import DialogBankOfTalents from './DialogBankOfTalents';

export default DialogBankOfTalents;
